export enum LockSubject {
  DataSource = "DataSource",
  ApiKey = "ApiKey",
}

export type ResourceLockedData = {
  subjectType: LockSubject;
};
